var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideLeftIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 47,
    viewBox: "0 0 16 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5C4.69442 5.5 8.5 9.30558 8.5 14V28C8.5 32.6944 4.69442 36.5 0 36.5H-0.5V5.5H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "side_flap",
    d: "M0 5.5C4.69442 5.5 8.5 9.30558 8.5 14V28C8.5 32.6944 4.69442 36.5 0 36.5",
    fill: "none",
    stroke: "#C7F1F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25106 21.5883C-0.0836864 21.2629 -0.0836864 20.7345 0.25106 20.4091L4.53582 16.244C4.87056 15.9187 5.41419 15.9187 5.74894 16.244C6.08369 16.5694 6.08369 17.0979 5.74894 17.4233L2.0694 21L5.74626 24.5767C6.08101 24.9021 6.08101 25.4306 5.74626 25.756C5.41152 26.0813 4.86789 26.0813 4.53314 25.756L0.248382 21.5909L0.25106 21.5883Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideLeftIco);
export default __webpack_public_path__ + "static/media/Side_left_ico.8d0682673e770c85a584c49af81a6e3c.svg";
export { ForwardRef as ReactComponent };